import React, { useEffect, useState } from 'react';
import './imageUploader.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';

const BoxImageUploader = ({ profileImage, setProfileImage }) => {
    const [image, setImage] = useState(null);

    useEffect(() => {
        setImage(profileImage)
    }, [profileImage])

    // Function to handle file input change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setProfileImage(file);
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
                // setProfileImage(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setImage(null);
        }
    };

    return (
        <div className="box-image-container">
            {/* Display uploaded image if available */}
            {!image ?
                <div className='no-profile'>
                    <input type="file" accept="image/*" onChange={handleFileChange} />
                    <FontAwesomeIcon icon={faImage} size='xl' />
                </div>
                : <div className="image-wrapper">
                    <img src={image} alt="Uploaded" />
                    <span className="remove-image" onClick={() => { setImage(null); setProfileImage(null); }}>
                        <FontAwesomeIcon icon={faTimesCircle} size="lg" />
                    </span>
                </div>}
            <label className="custom-file-upload">
                <input type="file" accept="image/*" onChange={handleFileChange} />
                Upload Picture
            </label>
        </div>
    );
};

export default BoxImageUploader;
